import { render, staticRenderFns } from "./NumberPageWeb.vue?vue&type=template&id=1b24c3bf&"
import script from "./NumberPageWeb.vue?vue&type=script&lang=js&"
export * from "./NumberPageWeb.vue?vue&type=script&lang=js&"
import style0 from "./NumberPageWeb.vue?vue&type=style&index=0&id=1b24c3bf&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports